// extracted by mini-css-extract-plugin
export default {"header":"sectionHeader_header__+V+xl","heading":"sectionHeader_heading__iK0YY","subheading":"sectionHeader_subheading__1Xkty","actions":"sectionHeader_actions__-Y9kY"};